import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { withTranslation, useTranslation } from "react-i18next";
import { usePreCheckInContext } from "./contexts/PreCheckInContext";
import { convertToAmPm } from "../../utils/timeUtils";

const PickupKeys = () => {
  const [requestNumberOfKeys, setRequestNumberOfKeys] = useState(1);
  const {
    propertyUid,
    bookingNumber,
    language,
    data: { presets, configuration, guestService },
    components: { PreCheckInHeader, PreCheckInContainer },
  } = usePreCheckInContext();

  const history = useHistory();
  const { t } = useTranslation();
  useEffect(() => {}, []);

  const continueBtn = () => {
    if (configuration.paymentType) {
      goToCardList();
    } else {
      goToAdditionalInformation();
    }
  };

  const goToAdditionalInformation = () => {
    history.push(
      `/pre-checkin/${propertyUid}/booking/${bookingNumber}/additional-information?language=${language}`
    );
  };

  const goToCardList = () => {
    history.push(
      `/pre-checkin/${propertyUid}/booking/${bookingNumber}/cards?language=${language}`
    );
  };

  const increase = () => {
    if (requestNumberOfKeys < guestService.numberOfKeys) {
      setRequestNumberOfKeys(requestNumberOfKeys + 1);
    }
  };
  const decrease = () => {
    if (requestNumberOfKeys > 1) {
      setRequestNumberOfKeys(requestNumberOfKeys - 1);
    }
  };

  return (
    <>
      <PreCheckInContainer containerName="add-my-child">
        <PreCheckInHeader
          title={t("KEY_QUANTITY", "KEY QUANTITY")}
          headerLink
        />
        {guestService && (
          <>
            <section
              id="content"
              className="relative flex flex-col px-9 w-full flex-1 md:flex-0 pt-6">
              <p
                className="type-title xLarge mb-8 mt-6"
                style={{ color: presets.backgroundColorTopBar }}>
                {t("ALMOST_READY", "ALMOST READY!")}
              </p>

              <p className="type-regular medium mb-8 mt-6">
                {guestService.titleRequestNumberOfKeys}
              </p>

              <div className="flex flex-col mb-24">
                <p
                  style={{ color: presets.backgroundColorTopBar }}
                  className="type-title xLarge mb-6 text-center">
                  {t("HOW_MANY_KEYS", "HOW MANY KEYS")}
                  <br />
                  {t("DO_YOU_NEED", "DO YOU NEED?")}
                </p>
                <div className="flex flex-row mb-24 justify-center items-center preCheckinSubTitle">
                  <span
                    onClick={() => decrease()}
                    className="w-10 h-10 type-title xLarge leading-none rounded-full m-8 flex text-center justify-center items-center"
                    style={{
                      backgroundColor:
                        presets.requestNumberOfKeys === 1
                          ? "#DFE1E2"
                          : presets.backgroundColorTopBar,
                      color: presets.appHomeTextCallToAction,
                    }}>
                    -
                  </span>
                  <p>
                    <span className="type-title xxxxLarge">
                      {requestNumberOfKeys}
                    </span>
                  </p>
                  <span
                    onClick={() => increase()}
                    className="w-10 h-10 type-title xLarge leading-none rounded-full m-8 flex text-center justify-center items-center"
                    style={{
                      backgroundColor:
                        presets.requestNumberOfKeys <= guestService.numberOfKeys
                          ? presets.backgroundColorTopBar
                          : "#DFE1E2",
                      color: presets.appHomeTextCallToAction,
                    }}>
                    +
                  </span>
                </div>

                <p className="type-regular medium mb-8 mt-6 text-center">
                  {t("CHECK_IN_TIME_IS_AT", "Check-in time is at")}{" "}
                  {presets.amPm
                    ? convertToAmPm(configuration.checkInTimeText)
                    : configuration.checkInTimeText}
                  .
                </p>
              </div>

              <div className="flex flex-col mb-24">
                <p
                  style={{ color: presets.backgroundColorTopBar }}
                  className="type-title xLarge mb-6">
                  {t("HOW_TO_PICKUP_YOUR_KEYS", "HOW TO PICKUP YOUR KEYS")}
                </p>
                <p
                  className="type-regular medium mb-8 mt-6"
                  style={{ whiteSpace: "pre-line" }}>
                  {guestService.howToPickUpYourKey.replaceAll("\\n", "\n")}
                </p>
              </div>
              <button
                className={`app-button-ipad type-title medium ${presets.buttonStyleName}`}
                style={{
                  backgroundColor: presets.backgroundColorTopBar,
                  color: presets.appHomeTextCallToAction,
                }}
                onClick={() => continueBtn()}>
                {t("CONTINUE")}
              </button>
            </section>
            <button
              className="app-button-mobile type-title medium "
              style={{
                backgroundColor: presets.backgroundColorTopBar,
                color: presets.appHomeTextCallToAction,
                position: "fixed",
                bottom: 0,
                left: 0,
              }}
              onClick={() => continueBtn()}>
              {t("CONTINUE")}
            </button>
          </>
        )}
      </PreCheckInContainer>
    </>
  );
};

export default withTranslation()(PickupKeys);
